import { useTheme } from "next-themes";
import { useEffect, useRef } from "react";

export default function ForceLightMode({ children }: { children: React.ReactNode }) {
  const { theme, setTheme } = useTheme();
  const previousTheme = useRef(theme);

  useEffect(() => {
    previousTheme.current = theme;
    if (theme !== "light") {
      setTheme("light");
    }
    return () => {
      // Restore previous theme when leaving marketing pages
      if (previousTheme.current && previousTheme.current !== "light") {
        setTheme(previousTheme.current);
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <>{children}</>;
}
